<div class="logo">
  <a *ngIf="(hasCurrentApp$ | async) === true" [href]="(currentApp$ | async)?.serviceUri">
    <img class="logo__img" [src]="(currentApp$ | async)?.logoUri" [alt]="(currentApp$ | async)?.name" />
  </a>
  <a *ngIf="(hasCurrentApp$ | async) === false" routerLink="/">
    <img
      class="logo__img"
      src="https://storage.googleapis.com/wizbii/static-assets-v4/logos/SVG/RGB/WIZBII_Account.svg"
      alt="Logo WIZBII Account"
    />
  </a>
</div>
